<script setup lang="ts">
import type { VideoCardPlayIndicatorProps } from '.';

defineProps<VideoCardPlayIndicatorProps>();
</script>

<template>
	<div class="absolute inset-0 flex items-center justify-center">
		<div
			:class="[
				'flex size-11 items-center justify-center rounded-full bg-black transition-all duration-400',
				isVideoPlaying || isLoading
					? 'pointer-events-none scale-50 opacity-0'
					: 'scale-100 opacity-100'
			]"
		>
			<IconMaterialSymbolsLightPlayArrow class="size-7 text-white" />
		</div>
	</div>
</template>
